import { memo } from 'react';

import { BetControls } from './BetControls';
import { MultiplierDisplay } from './MultiplierDisplay';

export const BetPanel = memo(() => (
  <div className="bet-controls">
    <MultiplierDisplay />
    <BetControls />
  </div>
));
